import React, { useEffect, useRef } from 'react';
export default function ProductPhotoViewer({photos,index,name,onChange,onClose}:{photos:string[];index:number;name:string;onChange:(index:number)=>void;onClose:()=>void}) {
  const dialog=useRef<HTMLDialogElement>(null);
  useEffect(()=>{
    const el=dialog.current!;const before=document.body.style.overflow;
    el.showModal();document.body.style.overflow='hidden';
    return ()=>{el.close();document.body.style.overflow=before;};
  },[]);
  return <dialog ref={dialog} className="pd-photo-viewer" aria-label={`${name} photos`} onCancel={e=>{e.preventDefault();onClose();}} onClick={e=>{if(e.target===e.currentTarget)onClose();}}>
    <button autoFocus type="button" className="pd-photo-close" aria-label="Close product photo" onClick={onClose}>×</button>
    <img src={photos[index]} alt={`${name}, ${index+1} of ${photos.length}`} />
    <div className="pd-photo-controls">
      {photos.length>1&&<button type="button" onClick={()=>onChange((index+photos.length-1)%photos.length)}>← Previous photo</button>}
      <span aria-live="polite">{index+1} / {photos.length}</span>
      {photos.length>1&&<button type="button" onClick={()=>onChange((index+1)%photos.length)}>Next photo →</button>}
    </div>
  </dialog>;
}
